// extracted by mini-css-extract-plugin
export default {"oneuser_page":"ProfilePage_oneuser_page__t9PcR","back_link":"ProfilePage_back_link__if5-F"};